export enum DecisionConfirmationTypes {
	FROM_LEADER = "FROM_LEADER",
	FROM_ALL = "FROM_ALL",
	NONE = "NONE",
}
